module.exports = __webpack_public_path__ + "img/teaCaseWeb1.2c2b85cd.jpg";